export default __webpack_public_path__ + "static/media/arbit.ab04ec9b.png";